import React, { useState } from 'react';
import $ from 'jquery'; 
import axios from 'axios'; 
import FormValidator from '../../../inc/FormValidator';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import Button from '../../inc/Button';
import Collapse from '../../inc/Collapse'; 
import FieldsRenderer from '../../Purchase Orders Internal/Edit PO/FieldsRenderer'; 
import Helper from '../../../inc/Helper';
import { Form } from 'react-bootstrap';
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Popup from '../../Popup/Popup';

let cancelTokenSource = axios.CancelToken.source();
const AppFormsPopup = ({setClosePopupViewModal, reloadParentGrid}) => {
    const [popupFormData, setPopupFormData] = useState({}); 
 
    const [apiCallBtn, setApiCallBtn] = useState(false);
 
    let popupFormValidator;   

    const validationConfigure = () => {
        let popupFieldConfig = [  
            {name:'name', displayName: 'Name', types:['Required']},
            {name:'redirect_uri', displayName: 'Redirect URI', types:['Required']}
        ];
     
        if(!popupFormValidator) {
            popupFormValidator = new FormValidator(popupFieldConfig)
        };
    };

    validationConfigure();

    const fieldsArrayGeneral = [
        {className:'col-lg-4', required: true, label: "Name", inputType: "text", id:'name', name:'name'},
        {className:'col-lg-4', required: true, label: "Redirect URI", inputType: "text", id:'redirect_uri', name:'redirect_uri'}
    ];

    const onClosePopupClick = () => {
        $("html").removeClass("rs_popup_open");
        setClosePopupViewModal(false);
    };

    const executePOSTPopupDocumentAPI = async () => {
        try { 
            let api = Api;
            api.setUserToken();
        
            const res = await api.axios().post(Settings.apiAppUrl + '/app/', popupFormData,
            { cancelToken: cancelTokenSource.token });

            if (res?.data?.success) {
                Helper.alert(res?.data?.message || 'App created successfully', 'success');  
                reloadParentGrid();
                onClosePopupClick();
            } else {
                Helper.alert(res?.data?.message, 'error')
            }
        } catch (error) { 
            getPopupMessageBasedOnStatus(error); 
        }
    };

    const handleSubmit = () => { 
        if(!popupFormValidator.isValid({...popupFormData})){
            popupFormValidator.displayMessage();
            popupFormValidator.reset();
            return;
        };
  
        Helper.createDebouncedAPIFunction( 
            [executePOSTPopupDocumentAPI], 
            setApiCallBtn,
            cancelTokenSource
        )(); 
    };

    return (
        <Popup
            autoOpen={true} width="900px"
            onClose={onClosePopupClick}
        > 
            <>
                <h5 className="create_rfq_modal__title">Create App</h5>

                <Collapse
                    className="mt-4 mb-4" open={true}
                    title={"General Information"}
                >
                    <Form>
                        <div className='container-fluid'>
                            <FieldsRenderer updateState={setPopupFormData} currentState={popupFormData} fieldsArray={fieldsArrayGeneral} />
                        </div>
                    </Form> 
                </Collapse> 
            </> 

            <div className="addDocumentNumber-body-buttons" style={{ justifyContent: "flex-end" }}>
                <Button
                    isActive={false} title={"Cancel"}
                    onClick={onClosePopupClick}
                />
                <Button
                    isDisable={apiCallBtn}
                    className="solid_btn" 
                    isActive={true}
                    title={<div><span> {"Create"} </span> {apiCallBtn ? <output className="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output> : ''}</div>}
                    onClick={handleSubmit}
                />
            </div>
        </Popup>
    )
};

export default (AppFormsPopup); 